export enum EmployeesAction {
  AddOrUpdateEmployee = 'ADD_OR_UPDATE_EMPLOYEE',
  SetEmailError = 'SET_EMAIL_ERROR',
  SetTab = 'SET_TAB_EMPLOYEE',
  FetchEmployees = 'FETCH_EMPLOYEES',
  SetEmployees = 'SET_EMPLOYEES',
  DeleteEmployee = 'DELETE_EMPLOYEE',
  EditEmployee = 'EDIT_EMPLOYEE',
  SetEmployeeLoading = 'SET_EMPLOYEE_LOADING',
}
